import { render, staticRenderFns } from "./AddOperatingLanguageDialog.vue?vue&type=template&id=0c1f97e4&scoped=true"
import script from "./AddOperatingLanguageDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AddOperatingLanguageDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AddOperatingLanguageDialog.vue?vue&type=style&index=0&id=0c1f97e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1f97e4",
  null
  
)

export default component.exports